import React from 'react';

import { useBelow } from '@/hooks/useBelow';

import { Checkbox } from '../ui/Checkbox/Checkbox';
import { CheckMarkIcon } from '../ui/Icons/Icons';
import { Typography } from '../ui/Typography/Typography.styles';
import * as S from './TariffCard.styles';

interface TariffCardProps {
  isSelected: boolean;
  info?: string | null;
  discount?: string | null;
  title: string;
  price: number;
  description: string;
  onClick?: () => void;
  hasError?: boolean;
  onBlur?: () => void;
  dataCy?: string;
}

export const TariffCard: React.FC<TariffCardProps> = ({
  isSelected,
  info,
  discount,
  title,
  price,
  description,
  onClick,
  hasError,
  onBlur,
  dataCy
}) => {
  const isMobile = useBelow('tablet');
  const text = description.split('\n').filter(line => line);

  return (
    <S.Wrapper
      as="button"
      type="button"
      data-cy={dataCy}
      onBlur={onBlur}
      onClick={onClick}
      $isSelected={isSelected}
      $hasError={hasError}
    >
      {discount && (
        <S.Label>
          <Typography variant="caption4">{discount}</Typography>
        </S.Label>
      )}
      <S.Header $isSelected={isSelected}>
        {isMobile ? (
          <S.TitleWrapper>
            <Typography variant="h5">{title}</Typography>
            <S.RightSectionWrapper>
              <Typography htmlTag="p" variant="h1">
                {price} ₼
              </Typography>
              <Checkbox isChecked={isSelected} readOnly />
            </S.RightSectionWrapper>
          </S.TitleWrapper>
        ) : (
          <>
            <S.TitleWrapper>
              <Typography variant="h5">{title}</Typography>
              <Checkbox isChecked={isSelected} readOnly />
            </S.TitleWrapper>
            <Typography htmlTag="p" variant="h0">
              {price} ₼
            </Typography>
          </>
        )}
      </S.Header>
      <S.ContentWrapper>
        {text?.map(item => (
          <S.DescriptionWrapper key={item}>
            <CheckMarkIcon /> <Typography variant="body3">{item}</Typography>
          </S.DescriptionWrapper>
        ))}

        {info && (
          <S.PopularChoice>
            <Typography variant="caption4">{info}</Typography>
          </S.PopularChoice>
        )}
      </S.ContentWrapper>
    </S.Wrapper>
  );
};
